import { useAtom } from 'jotai'

import { chatStatusAtom } from '@/store/gigiChat/Visuals'

import LastResponseTime from './LastResponseTime'

const Container = ({ promptId }: { promptId: number | null }) => {
    const [chatStatus] = useAtom(chatStatusAtom)

    const process = chatStatus?.asyncProcesses.find((process) => process.data.userPromptId === promptId)
    const lastResponseTime = process?.data.lastResponseTime || null

    const getTimeDifference = (timestamp: string) => {
        const now = new Date()
        const past = new Date(timestamp)
        const diffInMs = now.getTime() - past.getTime()
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60))
        if (diffInMinutes === 0) return null
        if (diffInMinutes === 1) return '1 minute ago'
        return `${diffInMinutes} minutes ago`
    }

    const timeAgo = lastResponseTime ? getTimeDifference(lastResponseTime) : null

    return <LastResponseTime value={timeAgo} />
}

export default Container
